

































































































import CommonBase from "../CommonBase";
import {Component, Inject, Prop} from "vue-property-decorator";
import {CardUserdata, Company} from "../../modules/models";
import BaseApi from "../../store/modules/base";
import rd from "../../modules/vRoutedefs";
import {hasIosAppInterface} from "@/modules/utils";

@Component
export default class SideNav extends CommonBase {
    @Inject()
    baseApi!: BaseApi;

    @Prop({default: null})
    userdata!: CardUserdata | null;

    readonly routedefs = rd;

    get usersExpanded() {
        const path = this.$route.path;
        return path.startsWith(rd.users.path);
    }
    get superExpanded() {
        const path = this.$route.path;
        return path.startsWith(rd.super.path);
    }

    get overviewExpanded() {
        const path = this.$route.path;
        return path.startsWith(rd.start.path);
    }

    get shopExpanded() {
        const path = this.$route.path;
        return path.startsWith(rd.shop.path);
    }

    noop() {}

    get activeCompany() {
        return this.baseApi.company;
    }

    @Prop({default: 0})
    unreadMsgsCount!: number;

    get person() {
        return this.userdata != null ? this.userdata.person : null;
    }

    get usersCompanies(): Company[] {
        return this.userdata != null ? this.userdata.usersCompanies() : [];
    }

    get orgnum() {
        return this.activeCompany != null ? this.activeCompany.orgNum : null;
    }

    get isAdmin() {
        if(this.orgnum != null && this.userdata != null) {
            return this.userdata.isCompanyAdmin(this.orgnum) || this.userdata.isCompanySuper(this.orgnum);
        }
        return false;
    }
    get isSuper() {
        return this.orgnum != null && this.userdata != null && this.userdata.isCompanySuper(this.orgnum);
    }

    get loginTo() {
        return {name: rd.public.name};
    }
    get signupTo() {
        return {name: rd.login.missing.name, query: {signup: true}};
    }
    get forgotTo() {
        return {name: rd.login.missing.name};
    }
    get userOverviewTo() {
        return {name: rd.start.name};
    }
    get userSelfDisplayTo() {
        return {name: rd.start.me.name};
    }
    get userReghistTo() {
        return {name: rd.start.me.registrations.name};
    }
    get userReghistTitle() {
        return rd.start.me.registrations.title;
    }
    get companyTo() {
        return {name: rd.company.name};
    }
    get locationOverviewTo() {
        return {name: rd.locations.name};
    }
    get terminalOverviewTo() {
        return {name: rd.terminals.name};
    }
    get useradminTo() {
        return {name: rd.users.name};
    }
    get userMsgsTo() {
        return {name: rd.usermessages.name};
    }
    get settingsTo() {
        return {name: rd.system.name};
    }
    get documentationTo() {
        return {name: rd.docs.name};
    }
    get superIndexTo() {
        return {name: rd.super.name};
    }
    get userReportsTo() {
        return {path: rd.users.reports.path};
    }
    get superSimTo() {
        return {name: rd.super.sims.name};
    }
    get superUsagestatsTo() {
        return {name: rd.super.usagestats.name};
    }
    get cardAddTo() {
        return {path: rd.start.card.add.path};
    }
    get showCardAdd() {
        return this.baseApi.config.qrCardConnectAvailable;
    }

    get shouldShowAccountInit() {
        // #AppleCompliance
        // Account init nav link must be hidden when in iOS app to comply with Apple guidelines/avoid app being blocked.
        return !hasIosAppInterface();
    }

    get accountInitTo() {
        return {name: rd.company.init.name};
    }
    get shopTo() {
        return {name: rd.shop.name};
    }
    get orderlistTo() {
        return {name: rd.shop.orders.name};
    }
    get accountSignupTo() {
        return {name: rd.public.signup.name};
    }
    get userRegreminderTo() {
        return {name: rd.start.me.regreminder.name};
    }
    get aboutTo() {
        return {name: rd.about.name};
    }
    get alertsTo() {
      return {name: rd.start.me.notifications.name};
    }
    get infectiontraceTo() {
      return {name: rd.users.reports.infectiontrace.name};
    }
    readonly videosTo = {name: rd.public.videos.name};
}
